(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .controller("OnlineExamPreviewCtrl", ["$scope", onlineExamPreviewCtrl]);
    function onlineExamPreviewCtrl($scope) {
        var vm = this;
        $scope.$parent.vm.buttons = "goToExam.tpl";
        vm.exam = $scope.$parent.vm.assignment.specificInfo;
        switch (vm.exam.proctorTypeId) {
            case 0:
                vm.proctor = "learningItem.onlineExam.proctored.notProctored";
                break;
            case 1:
                vm.proctor = "learningItem.onlineExam.proctored.proctored";
                break;
        }
    }
}());
